import {
  friendlyProgressStatus,
  isToolProgressEvent,
  mergeToolProgressDetails,
} from '../appShell/progressLabelVocabulary.js'

export const MAX_PROGRESS_ROWS = 40
const TOOL_ROW_PATTERN = /^Used \d+ tools? ·/

export function buildStreamProgressPatch(prev, event, traceText, summary, seen) {
  const existingDetails = Array.isArray(prev.thoughtDetails) ? prev.thoughtDetails : []
  const nextToolCount = nextStreamToolCount(prev, event)
  const nextDetails = isToolProgressEvent(event)
    ? mergeToolProgressDetails(
        existingDetails,
        nextToolCount,
        friendlyProgressStatus(event.status),
        MAX_PROGRESS_ROWS,
      )
    : traceDetails(existingDetails, traceText)
  return {
    thoughtSummary: summary || prev.thoughtSummary || 'Working…',
    thoughtDetails: nextDetails,
    autoExpandPreamble: true,
    streamProgressEventIds: Array.from(seen).slice(-MAX_PROGRESS_ROWS),
    streamProgressToolCount: nextToolCount,
    createdAt: Date.now(),
  }
}

function nextStreamToolCount(prev, event) {
  const current = Number(prev.streamProgressToolCount || 0)
  return isToolProgressEvent(event) ? current + 1 : current
}

function traceDetails(existingDetails, traceText) {
  const details = Array.isArray(existingDetails) ? existingDetails : []
  const toolRows = details.filter((detail) => TOOL_ROW_PATTERN.test(detail))
  const nextDetails = details.filter((detail) => !TOOL_ROW_PATTERN.test(detail))
  if (traceText) nextDetails.push(traceText)
  return [...nextDetails, ...toolRows].filter(Boolean).slice(-MAX_PROGRESS_ROWS)
}
